// src/App.js
import React from 'react';
import AppRoutes from './routes/AppRoutes';
import Toast from './components/Toast';

function App() {
  return (
    <>
      <Toast />
      <AppRoutes />
    </>
  );
}

export default App;
